// @flow

import { type UserInputValidationError, VALID } from '@tectonics/prs/validation';

export function validator(): ?UserInputValidationError {
  return VALID;
}
